export default {
  server: {
    server_name: "Server",
    player_name: "Character",
    nobind: "Unbound",
  },
  pop: {
    pleaseIn: "Please enter",
    pleaseSelect: "Please select",
    phone: "Please enter a mobile number",
    gnjoy: " Please enter a GNJOY account",
    onlineNo: "Please enter RO Online account",
    onlineServe: "Please select a RO Online server",
    twilightServe: "Please select a RO Twilight server",
    twilightRole: "Please select a RO Twilight character",
    tips1:
      "*Bind RO Online account now and complete the page’s specified quest to gain all rewards above.",
    tips2:
      "*Not binding RO Online account is regarded as forfeiting the RO Online rewards, but it won’t affect rewards from “RO Twilight”.",
    //
    pleaseLogin: "Please Log In First",
    changeSuccess: "Binding Changed Successfully",
    giftSuccess: "Pack Issued",
    phoneBlock: "Phone Number Cannot Be Empty",
    correctPhone: "Enter a Valid Phone Number",
    selectServe: "Please Select a Server",
  },
};
